import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { STAGE_TASK_CHOICE } from 'constants'

export default compose(
  firebaseConnect(props => [`users/${props.uid || ''}`]),
  connect(({ interactions, firebase: { profile } }) => ({
    uid: profile.uid,
    stage: profile.stage || STAGE_TASK_CHOICE,
    modalMode: interactions.modalMode,
  }))
)



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomePage/HomePage.enhancer.js